module.exports = __webpack_public_path__ + "img/ic_running_car.dd5e1479.png";